import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { GameDevelopersContext, IGameDevelopersContext } from '../../gameDevelopersState/gameDevelopersContext';
import Item from './components/Item';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import classNames from 'classnames';
import style from './GameDevelopers.module.scss';

const GameDevelopers: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, gameDevelopers, currentPage, countOfItems } =
		useContext<IGameDevelopersContext>(GameDevelopersContext);
	const developersHeadingClasses = classNames(style.developers, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<>
			{gameDevelopers.gameDevelopersCount ? (
				<div className={style.container} data-test="GameDevelopers">
					<div className={style.tableHeaders}>
						<Text
							className={developersHeadingClasses}
							translationNameSpace="listing"
							translationKey="developersLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<Text
							className={actionHeadingClasses}
							translationNameSpace="listing"
							translationKey="actionLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
					</div>
					{gameDevelopers.gameDevelopers.map((item, index) => (
						<Item data={item} key={item.id} index={index} />
					))}
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={gameDevelopers.gameDevelopersCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default GameDevelopers;
